import { render, staticRenderFns } from "./BaseCheckboxV3.vue?vue&type=template&id=afdb0e50&scoped=true&"
import script from "./BaseCheckboxV3.vue?vue&type=script&lang=js&"
export * from "./BaseCheckboxV3.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckboxV3.vue?vue&type=style&index=0&id=afdb0e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdb0e50",
  null
  
)

export default component.exports